import { HttpBackend, HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { DefaultLocale } from '@app/+authenticated/shared/locale/locale.helper';
import { TranslateService } from '@ngx-translate/core';
import { map, type Observable } from 'rxjs';

export const DOCX_MIME_TYPE = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

const EXAMPLE_CONTRACT_BY_LOCALE: Record<string, string> = {
  'en-GB':
    'https://assets.shiftbase.com/hubfs/application/Shiftbase_Example_Contract_with_variables_August_2025_EN.docx',
  'nl-NL':
    'https://assets.shiftbase.com/hubfs/application/Shiftbase_Example_Contract_with_variables_August_2025_NL.docx',
  'de-DE':
    'https://assets.shiftbase.com/hubfs/application/Shiftbase_Example_Contract_with_variables_August_2025_DE.docx',
};

/**
 * Fetches the sample contract from the asset host. It goes through `HttpBackend` because the
 * app's interceptors add cache headers to every GET, and the host only answers simple requests.
 */
@Injectable({ providedIn: 'root' })
export class SampleContractService {
  #http = new HttpClient(inject(HttpBackend));
  #translate = inject(TranslateService);

  fetch(): Observable<File> {
    const url =
      EXAMPLE_CONTRACT_BY_LOCALE[this.#translate.getCurrentLang() ?? DefaultLocale] ??
      EXAMPLE_CONTRACT_BY_LOCALE[DefaultLocale];
    const name = url.slice(url.lastIndexOf('/') + 1);

    return this.#http
      .get(url, { responseType: 'blob' })
      .pipe(map((blob) => new File([blob], name, { type: DOCX_MIME_TYPE })));
  }
}
